// 图像编辑相关翻译

export const editing = {
    // 图像编辑面板
    imageEditingPanel: '圖像編輯面板',
    uploadImage: '上傳圖片',
    uploadImageDescription: '上傳圖片開始編輯',
    dragDropImage: '拖拽圖片到此處，或點擊選擇',
    dragOrClickUpload: '拖拽圖片到此處，或點擊選擇',
    supportedFormats: '支援格式：JPG、PNG、WebP',
    maxFileSize: '最大檔案大小：10MB（剩餘 {remaining} 個位置）',
    uploadedImages: '已上傳圖片（{count}）',
    fileRejectedError: '檔案被拒絕。請檢查格式和大小。',
    slotsRemainingError: '僅剩 {slots} 個位置',
    uploadImageFirst: '請先上傳圖片',
    
    // 编辑功能
    conversationalEditing: '對話式編輯',
    conversationalEditingDescription: '描述您想要進行的更改',
    conversationalEditingFeature: '自然語言編輯指令',
    multiImageReference: '多圖片參考支援',
    intelligentUnderstanding: '智能理解編輯意圖',
    
    // AI图像编辑
    aiImageEditing: 'AI圖像編輯',
    quickStyles: '快速風格',
    quickStyleOptions: {
      enhancedetails: '增強細節',
      artstyle: '藝術風格',
      animestyle: '動漫風格', 
      realisticphoto: '真實照片'
    },
    describeEffect: '描述您想要的效果',
    describeEffectPlaceholder: '例如：讓它看起來像油畫，添加戲劇性光線，改為動漫風格...',
    
    // 样式提示
    stylePrompts: {
      enhanceDetails: '增強圖像細節和銳度',
      artStyle: '轉換為藝術風格',
      animeStyle: '轉換為動漫/漫畫風格',
      realisticPhoto: '讓它看起來像真實照片'
    },
    
    // 编辑错误处理
    editingGeneralError: '圖像編輯失敗',
    editingRateLimitError: '編輯速率限制超出',
    editingInsufficientCreditsError: '編輯積分不足',
    editingNetworkError: '編輯過程中網絡錯誤',
    imageEditingTimeout: '圖像編輯超時',
    checkEditingStatusFailed: '檢查編輯狀態失敗',
    
    // 编辑操作
    editingOptions: '編輯選項',
    styleTransfer: '風格轉換',
    enhancement: '增強',
    filters: '濾鏡',
    adjustments: '調整',
    
    // 样式转换
    selectStyle: '選擇風格',
    applyStyle: '應用風格',
    styleStrength: '風格強度',
    preserveDetails: '保留細節',
    
    // 增强选项
    enhanceQuality: '品質增強',
    upscale: '放大',
    denoising: '降噪',
    sharpening: '銳化',
    
    // 滤镜
    vintage: '復古',
    blackWhite: '黑白',
    sepia: '棕褐色',
    vibrant: '鮮豔',
    cool: '冷色調',
    warm: '暖色調',
    
    // 调整
    brightness: '亮度',
    contrast: '對比度',
    saturation: '飽和度',
    hue: '色調',
    
    // 操作按钮
    reset: '重置',
    apply: '應用',
    save: '保存',
    processing: '處理中...',
    
    // 错误和状态
    uploadError: '上傳失敗，請重試',
    processingError: '處理失敗，請重試',
    imageProcessed: '圖片處理成功',
    
    // 图像到图像
    imageToImageGeneration: '圖像到圖像生成',
    referenceImage: '參考圖片',
    generationPrompt: '生成提示詞',
    strength: '強度',
    strengthDescription: 'AI修改原始圖像的程度',
    
    // 文本到图像面板
    textToImagePanel: '文字轉圖像面板',
    generateFromText: '從文字生成',
    textPrompt: '文字提示詞',
    negativePrompt: '負面提示詞',
    negativePromptPlaceholder: '您不希望在圖像中看到的內容...',
    
    // 高级设置
    advancedSettings: '高級設置',
    seed: '種子',
    steps: '步數',
    guidanceScale: '引導比例',
    sampler: '採樣器'
  };
